export default "__VITE_ASSET__uOqIs13b__"